import { render, staticRenderFns } from "./SelectCorporatesModal.vue?vue&type=template&id=0ed493aa&scoped=true&"
import script from "./SelectCorporatesModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./SelectCorporatesModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed493aa",
  null
  
)

export default component.exports